export { default } from '@material-ui/core/ListItemText';

export type ListItemTextProps = import('@material-ui/core/ListItemText').ListItemTextProps;
